import * as React from 'react';
import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@epoch-ui/lib/utils';

const toggleVariants = cva(
  'tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-text-sm tw-font-medium tw-ring-offset-background tw-transition-colors hover:tw-bg-muted hover:tw-text-muted-foreground focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50 data-[state=on]:tw-bg-accent data-[state=on]:tw-text-accent-foreground',
  {
    variants: {
      variant: {
        default: 'tw-bg-transparent',
        outline:
          'tw-border tw-border-input tw-bg-transparent hover:tw-bg-accent hover:tw-text-accent-foreground',
        primary:
          'tw-border-[1.5px] tw-border-solid tw-border-border-grey tw-text-primary-grey tw-bg-background-grey hover:tw-bg-light-blue-badge hover:tw-text-primary-blue hover:tw-border-primary-blue data-[state=on]:tw-text-primary-blue data-[state=on]:tw-bg-light-blue-badge data-[state=on]:tw-border-primary-blue tw-rounded-lg'
      },
      size: {
        default: 'tw-px-3',
        sm: 'tw-h-9 tw-px-2.5',
        lg: 'tw-h-11 tw-px-5'
      }
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default'
    }
  }
);

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleVariants({ variant, size, className }))}
    {...props}
  />
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };
